import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useLanguage } from '../contexts/LanguageContext';

function Copyright() {
  const { translations } = useLanguage();
  
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {translations.footer_section.copyright} {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const { translations } = useLanguage();

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 6 },
        py: { xs: 6, sm: 8 },
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' },
          gap: { xs: 4, sm: 6 },
          justifyContent: 'center',
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 2 }}>
            {translations.footer_section.product}
          </Typography>
          <Stack spacing={1} alignItems="center">
            <Link color="text.secondary" variant="body2" href="#features">
              {translations.features}
            </Link>
            <Link color="text.secondary" variant="body2" href="#testimonials">
              {translations.testimonials}
            </Link>
            <Link color="text.secondary" variant="body2" href="#highlights">
              {translations.highlights}
            </Link>
            <Link color="text.secondary" variant="body2" href="#pricing">
              {translations.pricing}
            </Link>
            <Link color="text.secondary" variant="body2" href="#faq">
              {translations.faq}
            </Link>
            <Link color="text.secondary" variant="body2" href="#contact">
              {translations.contact_us}
            </Link>
          </Stack>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 2 }}>
            {translations.footer_section.company}
          </Typography>
          <Stack spacing={1} alignItems="center">
            <Link color="text.secondary" variant="body2" href="#">
              {translations.footer_section.about_us}
            </Link>
          </Stack>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 2 }}>
            {translations.footer_section.legal}
          </Typography>
          <Stack spacing={1} alignItems="center">
            <Link
              color="text.secondary"
              variant="body2"
              href="/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translations.footer_section.terms_conditions}
            </Link>
            <Link
              color="text.secondary"
              variant="body2"
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translations.footer_section.privacy_policy}
            </Link>
          </Stack>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pt: { xs: 4, sm: 6 },
          width: '100%',
          maxWidth: '800px',
          borderTop: '1px solid',
          borderColor: 'divider',
          margin: '0 auto',
        }}
      >
        <Copyright />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            color="inherit"
            size="small"
            href="https://www.instagram.com/rewardiou"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ alignSelf: 'center' }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href="https://www.twitter.com/rewardiou2024"
            aria-label="Twitter"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ alignSelf: 'center' }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}
            >
              X
            </Typography>
          </IconButton>
        </Box>
      </Box>
    </Container>
  );
}
